import React from 'react';
import { motion } from 'framer-motion';
import { aboutme } from '../constants';

function About() {
  return (
    <motion.div
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    transition={{ duration: 1.5 }}
    className="z-0 h-screen flex flex-col relative text-center md:text-left md:flex-row max-w-7xl px-10 justify-evenly mx-auto items-center"
  >
    <h3 className="absolute top-24 uppercase tracking-widest text-gray-500 text-2xl"></h3>
    {aboutme.map((about) => (
      <>
    <motion.img
      initial={{
        x: -200,
        opacity: 0,
      }}
      transition={{
        duration: 1.2,
      }}
      whileInView={{ opacity: 1, x: 0 }}
      src={about.imgURL}
      className=" hidden md:flex mb-2 lg:mb-20 md:mb-8 flex-shrink-0 w-40 h-40 rounded-full object-cover md:rounded-lg md:w-[200px] md:h-[280px] xl:w-[410px] xl:h-[450px]"
    />

    <div className="space-y-10 px-0 md:px-10 ">
      <h4 className="text-2xl lg:text-3xl font-semibold">
        Here is a <span className="underline decoration-[#F7AB0A]/50">little</span>{" "}
        background
        <div className="text-[12px] md:text-base font-light">{about.text}</div>
      </h4>
    </div>
    </>
  ))}
  </motion.div>
  )
}

export default About
